var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55714 9.80724C4.47795 10.5544 3.83398 11.7834 3.83398 13.096V25.0002C3.83398 27.2093 5.62485 29.0002 7.83398 29.0002L11.834 29.0002V24.0002C11.834 21.7911 13.6248 20.0002 15.834 20.0002H17.834C20.0431 20.0002 21.834 21.7911 21.834 24.0002V29.0002L25.834 29.0002C28.0431 29.0002 29.834 27.2093 29.834 25.0002V13.096C29.834 11.7834 29.19 10.5544 28.1108 9.80724L19.1108 3.57647C17.741 2.62816 15.9269 2.62816 14.5571 3.57646L5.55714 9.80724Z",
    fill: "#F5DADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83398 13.0958C3.83398 11.7832 4.47795 10.5542 5.55714 9.80704L14.5571 3.57627C15.9269 2.62796 17.741 2.62797 19.1108 3.57627L28.1108 9.80704C29.19 10.5542 29.834 11.7832 29.834 13.0958V25C29.834 27.2091 28.0431 29 25.834 29H7.83398C5.62485 29 3.83398 27.2091 3.83398 25V13.0958Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.834 24V29H21.834V24C21.834 21.7909 20.0431 20 17.834 20H15.834C13.6248 20 11.834 21.7909 11.834 24Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.3dabf981114a36fd115b3b7dac5e89ba.svg";
export { ForwardRef as ReactComponent };